import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { FloatingButtons } from './FloatingButtons';
import { ExitPopup } from './ExitPopup';

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [pathname, hash]);
  return null;
};

export const Layout = ({ children }) => (
  <div className="min-h-screen bg-white">
    <ScrollManager />
    <Header />
    <main>{children}</main>
    <Footer />
    <FloatingButtons />
    <ExitPopup />
  </div>
);
